<div [class]="skinName">
  @if (!cancelled) {
    <h2 class="uk-modal-title">
    {{ configService.localeKeys?.['plans.want_to_cancel_subcription.text'] }}</h2>
  }
  @if (cancelled) {
    <h2 class="uk-modal-title">
    {{ configService.localeKeys?.subsc_can_title_subscr_def }}</h2>
  }
  <div class="input-container">
    @if (!cancelled) {
      <div class="check">
        <img src="/branding/theme/assets/static_assets/ic-exclaimation-for-lbg.svg" alt="">
        <button class="uk-button button-sec-close uk-modal-close" type="button">{{ configService.localeKeys?.back_to_account }}</button>
        <button class="uk-button submit-btn" (click)="setCancelled()">{{ configService.localeKeys?.i_agree }}</button>
      </div>
    }
    @if (cancelled) {
      <div class="check">
        <img src="/branding/theme/assets/static_assets/ic-error-heart-on-lbg.svg" alt="">
        @if (paymentType !== 'free-plan') {
          <p class="cancelled-text">{{configService.localeKeys?.watch_untill_next_billing_date_infomation}} &nbsp;{{ expiryDate }}</p>
        }
      </div>
    }
  </div>

</div>